import React, { useEffect, useState } from "react";
import ProductCard from "../../../components/common/ProductCard";
import { ProductService } from "../../../services/productService";
import { getRecentProductIds } from "../../../utils/ProductUtil";

const RecentlyViewed = () => {
  const [products, setProducts] = useState([]);
  const fetchProducts = async () => {
    const ids = getRecentProductIds();
    if (ids.length === 0) {
      setProducts([]);
      return;
    }
    try {
      const response = await ProductService.getListProducts({
        page: 1,
        pageSize: 5,
        productIds: ids,
      });
      if (!response.Data) {
        // toast.error("Lỗi lấy danh sách sản phẩm!");
        return;
      }
      const { listData } = response.Data;
      setProducts(listData);
    } catch (error) {
      // toast.error("Lỗi lấy danh sách sản phẩm!");
    }
  };

  useEffect(() => {
    fetchProducts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (products.length === 0) return null;

  return (
    <div className="bg-white p-6 w-full lg:px-40">
      {/* Title */}
      <div className="mb-6">
        <span className="font-bold">Đã xem gần đây</span>
      </div>

      {/* Product Grid */}
      <div className="grid gap-4 grid-cols-2 sm:grid-cols-4 lg:grid-cols-5 grid-rows-2 sm:grid-rows-1 lg:grid-rows-1">
        {products.map((p, i) => (
          <div key={p._id || i} className={i >= 4 ? "hidden lg:block" : ""}>
            <ProductCard product={p} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default RecentlyViewed;
